import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/person_gray_150.png'


const _withScopeId = n => (_pushScopeId("data-v-03000d5d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "research-group-manage" }
const _hoisted_2 = {
  key: 0,
  class: "alert alert-primary alert-sm"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, " Owner ", -1))
const _hoisted_4 = { class: "owner" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_6 = { key: 1 }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Last updated", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Database file", -1))
const _hoisted_9 = { class: "actions" }
const _hoisted_10 = ["disabled"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", { class: "mb-1" }, "This will:"),
  /*#__PURE__*/_createElementVNode("ul", null, [
    /*#__PURE__*/_createElementVNode("li", null, "Stop sharing the tree with other users and groups"),
    /*#__PURE__*/_createElementVNode("li", null, "Permanently delete the online copy of your tree")
  ])
], -1))

import { computed, ref } from 'vue'
import { useRouter } from 'vue-router'
import { useDataGroupStore } from '@/gp/DataGroupStore'
import { useUserStore } from '@/gp/UserStore'
import { useWorkspaceStore } from '@/rd/WorkspaceStore'
import { useSyncStore } from '@/rd/SyncStore'
import { useFeatureStore, SyncChangesFeature } from '@/rd/FeatureStore'
import { ItemPermissions } from '@/gp/GroupAdminModel'
import { LockIcon, Trash2Icon } from '@zhuowenli/vue-feather-icons'
import { LoadMode } from '@/util/AsyncData'
import { DateTimeUtil } from '@/util/LuxonUtil'
import Modal from '@/util/Modal.vue'
import WorkspaceUpdatePanel from '@/sync/WorkspaceUpdatePanel.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ResearchGroupManage',
  props: {
    dataGroupId: {}
  },
  setup(__props: any) {

const props = __props;



const deleteGroupModalRef = ref<InstanceType<typeof Modal>>()

const dataGroupStore = useDataGroupStore()
const userStore = useUserStore()
const workspaceStore = useWorkspaceStore()
const syncStore = useSyncStore()
const featureStore = useFeatureStore()
const router = useRouter()

const dataGroupRef = computed(() => dataGroupStore.getAsyncGroup(props.dataGroupId, LoadMode.EnsureLoaded)?.data)
const ownerRef = computed(() => userStore.getAsyncUser(dataGroupRef.value?.ownerId, LoadMode.EnsureLoaded)?.data)
const workspaceRef = computed(() => workspaceStore.getAsyncWorkspacesForGroups([props.dataGroupId], LoadMode.EnsureLoaded).at(0)?.data)
const lastSyncRef = computed(() => syncStore.getAsyncSync(workspaceRef.value?.lastSyncId, LoadMode.EnsureLoaded)?.data)
const syncChangesEnabledRef = computed(() => featureStore.isFeatureEnabled(SyncChangesFeature))

const permissionsRef = computed(() => dataGroupStore.getAsyncPermissions(props.dataGroupId, LoadMode.EnsureLoaded)?.data ?? ItemPermissions.None)
const canEditRef = computed(() => (permissionsRef.value & ItemPermissions.Modify) > 0)
const canUpdateRef = computed(() => syncChangesEnabledRef.value && canEditRef.value)
const canDeleteRef = computed(() => (permissionsRef.value & ItemPermissions.Owner) > 0)

async function deleteGroup() {
  await dataGroupStore.deleteAsync(dataGroupRef.value!.id!)

  deleteGroupModalRef.value!.close() // get rid of static backdrop
  router.push('/trees')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!canEditRef.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_unref(LockIcon), { size: "1.2x" }),
          _createTextVNode(" You do not have permission to manage this tree. ")
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", null, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createTextVNode(" " + _toDisplayString(ownerRef.value?.displayName), 1)
      ])
    ]),
    (lastSyncRef.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("div", null, _toDisplayString(_unref(DateTimeUtil).toRelativePastDate(lastSyncRef.value.createdDate)), 1)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", null, [
      _hoisted_8,
      (canUpdateRef.value && workspaceRef.value)
        ? (_openBlock(), _createBlock(WorkspaceUpdatePanel, {
            key: 0,
            "workspace-id": workspaceRef.value.id!
          }, null, 8, ["workspace-id"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_9, [
      (canDeleteRef.value)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            type: "button",
            class: "btn btn-outline-danger",
            "data-bs-toggle": "modal",
            "data-bs-target": "#deleteGroupModal",
            disabled: !dataGroupRef.value
          }, " Delete online tree ", 8, _hoisted_10))
        : _createCommentVNode("", true)
    ]),
    _createVNode(Modal, {
      id: "deleteGroupModal",
      ref_key: "deleteGroupModalRef",
      ref: deleteGroupModalRef,
      "ok-style": "danger",
      onOk: deleteGroup
    }, {
      title: _withCtx(() => [
        _createTextVNode("Delete this tree?")
      ]),
      okText: _withCtx(() => [
        _createVNode(_unref(Trash2Icon), { size: "1.2x" }),
        _createTextVNode(" Delete online tree ")
      ]),
      busyText: _withCtx(() => [
        _createTextVNode("Deleting....")
      ]),
      default: _withCtx(() => [
        _hoisted_11
      ]),
      _: 1
    }, 512)
  ]))
}
}

})